/**
 * Chat Shell Layout
 *
 * Transparent route-group layout for chat-scoped pages.
 *
 * Primary responsibilities:
 * - Group chat and space routes under the shared dashboard shell
 * - Preserve public URLs while using a shared parent layout
 *
 * Dependencies:
 * - none
 */

'use client'

import { ReactNode } from 'react'
import { useRootMountMarker } from '@/components/utility/root-mount-marker'

interface ChatShellLayoutProps {
  children: ReactNode
}

export default function ChatShellLayout({ children }: ChatShellLayoutProps) {
  useRootMountMarker('chat-shell-layout')

  return children
}
